import { createApp, onMounted, ref } from 'vue'
import lazyPlugin from 'vue3-lazy'

import { Swiper, SwiperSlide } from 'swiper/vue'
import SwiperCore, { Navigation, Lazy} from 'swiper'

SwiperCore.use([Navigation, Lazy])

import initHeader from '../../config'
import './teams.scss'
import { useTeamSwiper, useSetNavigation } from './index'
import { isMobile } from '../../utils/info'

const App = {
    components: {
        Swiper, SwiperSlide
    },
    setup() {
        onMounted(function () {
            initHeader().init()
        })
        
        return {
            isMobile,
            ...useTeamSwiper(),
            ...useSetNavigation(),
        }
    }
}

createApp(App)
    .use(lazyPlugin, {})
    .mount('#app')
